var MouseEvent;
(function (MouseEvent) {
    MouseEvent["CLICK"] = "click";
    MouseEvent["DOUBLE_CLICK"] = "dblclick";
    MouseEvent["MOUSE_DOWN"] = "mousedown";
    MouseEvent["MOUSE_MOVE"] = "mousemove";
    MouseEvent["MOUSE_OUT"] = "mouseout";
    MouseEvent["MOUSE_OVER"] = "mouseover";
    MouseEvent["MOUSE_UP"] = "mouseup";
    MouseEvent["RELEASE_OUTSIDE"] = "releaseoutside";
    MouseEvent["MOUSE_DRAG_START"] = "mousedragstart";
    MouseEvent["MOUSE_DRAG"] = "mousedrag";
    MouseEvent["MOUSE_DRAG_STOP"] = "mousedragstop";
    MouseEvent["MOUSE_WHEEL"] = "mousewheel";
    MouseEvent["ROLL_OUT"] = "rollout";
    MouseEvent["ROLL_OVER"] = "rollover";
    MouseEvent["CONTEXT_MENU"] = "contextMenu";
})(MouseEvent || (MouseEvent = {}));
(function (MouseEvent) {
    MouseEvent.event = 'mouse';
    MouseEvent.type = null;
    MouseEvent.x = 0;
    MouseEvent.y = 0;
    MouseEvent.deltaX = 0;
    MouseEvent.deltaY = 0;
    MouseEvent.dragDeltaX = 0;
    MouseEvent.dragDeltaY = 0;
    MouseEvent.relatedObject = null;
    MouseEvent.buttonDown = false;
})(MouseEvent || (MouseEvent = {}));
export default MouseEvent;
